export const NAME_LENGTH_LIMIT = 64;

export function NameWithLimitLength(file: File): string {
  const splitValue: string[] = file.name.split(/\.(?=[^\.]+$)/);
  const extensionLength = splitValue[1].length + 1;
  return `${splitValue[0].slice(0, NAME_LENGTH_LIMIT - extensionLength)}.${splitValue[1]}`;
}
